/* Ürün kartı videoları (snippets/product-card.liquid):
   1) Hover videosu: ilk medya Shopify videosu olan kartta (koleksiyon ızgarası, hover_video: true) video yalnız
      gerçek fareli cihazda üstüne gelince data-src'den yüklenir, sessiz/döngüde oynar, çıkınca durur.
      Hareket azaltma veya veri tasarrufu açıksa oynatılmaz; dokunmatik cihazda hiç yüklenmez.
   2) custom.custom_card_video_url metafield'ı olan kartta oynat butonu videoyu pencerede açar
      (YouTube/Vimeo bağlantıları yeni sekmede açılır).
   Koleksiyon sayfası doğrudan yükler; diğer sayfalarda global.js on-demand modül olarak yükler (P.cardVideo). */
(function () {
  'use strict';
  var P = window.Patirti = window.Patirti || {};
  if (P.cardVideo) return;
  var HOVER_DELAY = 120; // Fare ızgarada gezinirken geçtiği her kart video indirmesin.

  function canHoverVideo() {
    if (!window.matchMedia) return false;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return false;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    var connection = navigator.connection;
    return !(connection && connection.saveData);
  }

  function videoOf(card) { return card.querySelector('video[data-hover-video]'); }

  function enter(card) {
    var video = videoOf(card);
    if (!video || !canHoverVideo()) return;
    card.__hvHovering = true;
    var gallery = video.closest('product-gallery-mini');
    // Video ile fotoğraflar aynı alanı paylaşır: bu kartta fareyle fotoğraf gezme kapanır (global.js).
    if (gallery) { gallery.setAttribute('data-video-active', ''); if (gallery.go) gallery.go(0, false); }
    if (!video.__hvBound) {
      video.__hvBound = true;
      video.muted = true;
      video.addEventListener('playing', function () { if (card.__hvHovering) video.classList.add('is-playing'); });
    }
    clearTimeout(card.__hvReset);
    clearTimeout(card.__hvStart);
    card.__hvStart = setTimeout(function () {
      if (!card.__hvHovering || !video.isConnected) return;
      if (!video.getAttribute('src')) video.src = video.getAttribute('data-src');
      var playing = video.play();
      // Fare hemen çıkarsa pause() bu isteği keser; beklenen durum.
      if (playing && playing.catch) playing.catch(function () {});
    }, HOVER_DELAY);
  }

  function leave(card) {
    card.__hvHovering = false;
    clearTimeout(card.__hvStart);
    var video = videoOf(card);
    if (!video) return;
    video.classList.remove('is-playing');
    if (!video.paused) video.pause();
    // Başa sarma solma bittikten sonra; yoksa geçişte kare zıplar.
    card.__hvReset = setTimeout(function () { if (!card.__hvHovering && video.readyState > 0) video.currentTime = 0; }, 220);
  }

  function cardFrom(node) { return node && node.closest ? node.closest('[data-product-card]') : null; }
  document.addEventListener('pointerover', function (event) {
    if (event.pointerType && event.pointerType !== 'mouse') return;
    var card = cardFrom(event.target);
    if (!card || card.__hvHovering || card.contains(event.relatedTarget)) return;
    enter(card);
  }, { passive: true });
  document.addEventListener('pointerout', function (event) {
    var card = cardFrom(event.target);
    if (!card || !card.__hvHovering || card.contains(event.relatedTarget)) return;
    leave(card);
  }, { passive: true });

  /* Metafield videosu penceresi */
  var modal = null, player = null;
  function ensureModal(closeLabel) {
    if (modal) return modal;
    modal = document.createElement('modal-dialog');
    modal.className = 'card-video-modal';
    modal.setAttribute('aria-label', 'Video');
    var backdrop = document.createElement('div');
    backdrop.setAttribute('data-dialog-backdrop', '');
    var content = document.createElement('div');
    content.className = 'card-video-modal__inner';
    content.setAttribute('data-dialog-content', '');
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'card-video-modal__close';
    close.setAttribute('data-dialog-close', '');
    close.setAttribute('aria-label', closeLabel || 'Kapat');
    close.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M18 6 6 18M6 6l12 12"/></svg>';
    player = document.createElement('video');
    player.controls = true;
    player.playsInline = true;
    player.preload = 'none';
    content.appendChild(close);
    content.appendChild(player);
    modal.appendChild(backdrop);
    modal.appendChild(content);
    modal.addEventListener('dialog:closed', function () {
      player.pause();
      player.removeAttribute('src');
      player.load();
    });
    (document.getElementById('patirti-overlays') || document.body).appendChild(modal);
    return modal;
  }

  function openVideo(button) {
    var raw = button.getAttribute('data-video-url') || '';
    var url;
    try { url = new URL(raw, location.href); } catch (_) { return; }
    if (!/^https?:$/.test(url.protocol)) return;
    if (/(^|\.)(youtube\.com|youtu\.be|vimeo\.com)$/.test(url.hostname)) { window.open(url.href, '_blank', 'noopener'); return; }
    // Koleksiyon sayfasında modül doğrudan yüklendiği için pencere stili burada istenir.
    var css = button.getAttribute('data-module-css');
    if (css && P.loadAsset) P.loadAsset(css).catch(function () {});
    var dialog = ensureModal(button.getAttribute('data-close-label'));
    if (!dialog.open) return;
    player.src = url.href;
    dialog.open(button);
    player.load();
    var playing = player.play();
    if (playing && playing.catch) playing.catch(function () {});
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-card-video]');
    if (!button) return;
    event.preventDefault();
    openVideo(button);
  });

  P.cardVideo = { handle: openVideo };

  // Modül yüklenirken fare zaten bir kartın üstündeyse onu da başlat.
  var hovered = document.querySelectorAll('[data-product-card]:hover');
  if (hovered.length) enter(hovered[hovered.length - 1]);
})();
